module.exports = __webpack_public_path__ + "img/gsjs_mobile_card.9ecd4aef.png";